import React from 'react';

import cn from 'classnames';
import { string } from 'prop-types';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';

import Layout from 'components/Common/Layout';

import useUserRedux from 'hooks/useUserRedux';
import { CREDENTIAL_WALLET } from 'routes/constants';

import CredentialsPublicShowPage from 'modules/CredentialWallet/Public/pages/CredentialShowPage';
import CredentialsPublicListPage from 'modules/CredentialWallet/Public/pages/CredentialsListPage';
import CredentialShowPage from 'modules/CredentialWallet/Student/pages/CredentialShowPage';
import CredentialsListPage from 'modules/CredentialWallet/Student/pages/CredentialsListPage';

import s from './CredentialWallet.css';

const CredentialWallet = ({ mode }) => {
  const { t } = useTranslation();
  const { isK12Admin } = useUserRedux();
  const isPublic = mode === 'public';
  const hasLayoutDetails = isK12Admin || !isPublic;

  const isIndex = window.location.pathname === CREDENTIAL_WALLET;

  return (
    <Layout
      color="green"
      appBar
      sideNav={hasLayoutDetails}
      appBarPageDetails={
        !hasLayoutDetails
          ? {}
          : {
              module: 'Student',
              title: t('CredentialWallet.CredentialWallet.CredentialWallet', {
                debugAsText: true,
              }),
            }
      }
      // We want to hide overflow on the index page
      // because the content container handles the scroll/avoid double scroll
      className={cn({ [s.hideOverflow]: isIndex })}
    >
      <Helmet>
        <title>
          {t('CredentialWallet.CredentialWallet.CredentialWallet', {
            debugAsText: true,
          })}
        </title>
      </Helmet>

      <Routes>
        {isPublic ? (
          <>
            <Route
              path=":type/:credentialId"
              element={<CredentialsPublicShowPage />}
            />

            <Route index element={<CredentialsPublicListPage />} />
          </>
        ) : (
          <>
            <Route
              path=":type/:credentialId"
              element={<CredentialShowPage />}
            />

            <Route index element={<CredentialsListPage />} />
          </>
        )}
      </Routes>
    </Layout>
  );
};

CredentialWallet.propTypes = {
  mode: string,
};

CredentialWallet.defaultProps = {
  mode: undefined,
};

export default CredentialWallet;
